"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Star: function() {
        return Star;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Star = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.6071 1.78917C11.11 0.531959 12.8897 0.531997 13.3925 1.78923L15.6932 7.54139L21.8889 7.92862C23.209 8.01112 23.7839 9.63766 22.8089 10.5314L18.122 14.8277L19.6573 20.5852C20.0006 21.8725 18.6205 22.9351 17.4637 22.2741L11.9998 19.1517L6.53551 22.2741C5.37877 22.9351 3.99868 21.8725 4.34196 20.5853L5.8773 14.8277L1.1904 10.5314C0.215385 9.63766 0.790317 8.01112 2.11042 7.92862L8.30606 7.54139L10.6071 1.78917ZM11.9998 3.69257L10.0456 8.57781C9.83037 9.11573 9.32465 9.48163 8.74642 9.51777L3.40834 9.8514L7.45205 13.5581C7.86384 13.9356 8.03175 14.5106 7.88782 15.0504L6.58298 19.9435L11.2556 17.2735C11.7168 17.01 12.2829 17.01 12.7441 17.2735L17.4163 19.9434L16.1115 15.0504C15.9675 14.5106 16.1354 13.9356 16.5472 13.5581L20.5909 9.8514L15.2529 9.51777C14.6746 9.48163 14.1689 9.11569 13.9537 8.57775L11.9998 3.69257Z",
        fill: "currentColor"
    })
}), "Star");
const _default = Star;
